<script>
  import { login } from "./login.mjs";

  let {
    endpoint,
    session,
    result,
    submitComponent = defaultSubmitComponent,
    footerComponent = defaultFooterComponent,
    messageComponent = defaultMessageComponent
  } = $props();

  let usernameInput;
  let passwordInput;
  let username = $state("");
  let password = $state("");
  let enabled = $derived.by(
    () =>
      username.length &&
      password.length &&
      passwordInput?.checkValidity() &&
      usernameInput?.checkValidity()
  );
  let active = $state(false);
  let message = $state();

  async function onsubmit(event) {
    event.preventDefault();
    if (!active) {
      try {
        active = true;
        message = await login(session, endpoint, username, password);
        if (!message && result !== undefined) {
          await result();
        }
      } catch (e) {
        message = e;
      } finally {
        active = false;
        password = "";
      }
    }
  }
</script>

{#snippet defaultFooterComponent(username, password, active)}{/snippet}

{#snippet defaultMessageComponent(mesage)}
  {#if message}
    <div class="error" id="message">{message}</div>
  {/if}
{/snippet}

{#snippet defaultSubmitComponent(username, password, active, enabled)}
  <button aria-keyshortcuts="Enter" type="submit" disabled={!enabled}>
    Login
    {#if active}
      <div class="spinner"></div>
    {/if}
  </button>
{/snippet}

<form {onsubmit}>
  {@render messageComponent(message)}
  <fieldset>
    <legend>Credentials</legend>
    <label>
      <span>Username</span>
      <input
        aria-label="username"
        aria-required="true"
        minlength="1"
        maxlength="75"
        size="32"
        autocorrect="off"
        autocapitalize="off"
        autocomplete="username"
        id="username"
        type="text"
        placeholder="Username"
        required
        disabled={active}
        bind:this={usernameInput}
        bind:value={username}
      />
    </label>
    <label>
      <span>Password</span>
      <input
        aria-label="password"
        aria-required="true"
        minlength="4"
        maxlength="50"
        size="32"
        autocorrect="off"
        autocapitalize="off"
        autocomplete="current-password"
        id="password"
        type="password"
        placeholder="Password"
        required
        disabled={active}
        bind:this={passwordInput}
        bind:value={password}
      />
    </label>
  </fieldset>

  {@render submitComponent(username, password, active, enabled)}
  {@render footerComponent(username, password, active)}
</form>

<style>
  #username,
  #password {
    display: block;
  }
</style>
